export default {
  computed: {
    showPreloader () {
      return this.displayedRequests.length < this.requests.length
    }
  },
  created () {
    this.$store.dispatch('fetchTeam')
    this.$store.dispatch('budgets/fetch')
  },
  data () {
    return {
      displayedRequests: [],
      filterBudgetId: undefined,
      showProcessed: false
    }
  },
  methods: {
    loadMore () {
      if (this.showPreloader) {
        const i = this.displayedRequests.length
        const j = this.requests.length
        const step = j - i < 50 ? j - i : 50
        this.displayedRequests.push(...this.requests.slice(i, i + step))
      }
    },
    proccessedFooter (r) {
      const processor = this.myTeam.find(u => u.id === r.processorId)
      const fields = {decision: r.status ? this.$t(`label.${r.status}`) : '', user: processor ? this.userName(processor) : '', date: this.toDate(r.processDate)}
      return this.$t(processor ? 'label.processedBy' : 'label.processedOn', fields)
    }
  },
  watch: {
    requests () {
      this.displayedRequests = this.requests.slice(0, 20)
    }
  }
}
